import React from 'react'
import { Link } from 'react-router-dom'
import { formatDistance } from 'date-fns'

import './styles/video-item.scss'

const VideoItem = props => {

  const { id, title, channelTitle, publishedAt, thumbnails } = props

  const date = formatDistance(new Date(publishedAt), new Date(), {addSuffix: true})

  let srcset = '', sizes = ''

  for (const res in thumbnails) {
    if (!res) return

    srcset += `${thumbnails[res].url} ${thumbnails[res].width}w `
    sizes += `(max-width: ${thumbnails[res].width}px) ${thumbnails[res].width}px `
  }

  return (
    <article className="video">
      <figure className="thumbnail-container">
        <img
          className="thumbnail"
          src={thumbnails?.default?.url}
          srcSet={srcset}
          //sizes={sizes}
          alt="A cool video"
          aria-label="Preview of the video"
        />
        <figcaption className="duration" aria-label="Video duration">
          10:23
        </figcaption>
      </figure>
      <h3 className="title">
        {title}
      </h3>
      <div className="meta-container">
        <p className="author">{channelTitle}</p>
        <time dateTime="" className="published">{date}</time>
      </div>
      <Link to={`/video/${id}`}
            className="link"
            aria-label="Watch the video">
        <span className="sr-only">Watch the video</span>
      </Link>
    </article>
  )
}

export default VideoItem